module.exports = __webpack_public_path__ + "static/media/intro_mobile.30407bb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Home/intro_mobile.svg
// module id = 81
// module chunks = 0